enum FutureStatus {
  initialized,
  loading,
  success,
  failure,
}
export default FutureStatus;
